import VoucherPartnerListView from "../../components/VoucherPartnerListView";

VoucherPartnerListScreen.propTypes = {};

function VoucherPartnerListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="container-fluid px-4 my-4">
                <VoucherPartnerListView />
            </div>
        </div>
    );
}

export default VoucherPartnerListScreen;
